import { Box, BoxProps, Stack } from "@mui/material";
import { IInvestmentUniverse, IWikifolioDetailDict } from "src/api/server/wf-detail.types";
import { Typography } from "src/components-mui/base/typography/typography";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { InvestmentUniverseGroup } from "src/components-mui/pages/detail/trading-idea-section/investment-universe-group";

const INVESTMENT_UNIVERSE_TEST_ID = "investment-universe";

interface IProps extends BoxProps {
    data: IInvestmentUniverse;
    dict: Pick<IWikifolioDetailDict, "investmentUniverseTitle" | "superWikifolioInvestmentUniverseParagraph">;
}

export const InvestmentUniverse = ({ data, dict, ...boxProps }: IProps) => {
    const { universeGroups, tooltip } = data;

    return (
        <Box data-test-id={INVESTMENT_UNIVERSE_TEST_ID} {...boxProps}>
            <Stack direction="row" sx={{ alignItems: "center", pt: 2 }}>
                <Typography component="h3" sx={{ fontWeight: "bold", fontSize: "lg" }}>
                    {dict.investmentUniverseTitle}
                </Typography>
                <WfPopover
                    PopoverTrigger={<PopoverButtonIconInfo ariaLabel={dict.investmentUniverseTitle} sx={{ ml: 1 }} />}
                    {...tooltip}
                    slotProps={{ popper: { zIndex: 1 } }}
                />
            </Stack>
            {dict.superWikifolioInvestmentUniverseParagraph && (
                <Typography component="p" sx={{ mt: 1, mb: 0 }}>
                    {dict.superWikifolioInvestmentUniverseParagraph}
                </Typography>
            )}
            <Stack direction="row" sx={{ flexWrap: "wrap", gap: 2, mt: 3 }}>
                {universeGroups.map(group => (
                    <InvestmentUniverseGroup key={group.universeGroupId} {...group} />
                ))}
            </Stack>
        </Box>
    );
};
